import AccettazioneList from "./pages/AccettazioneList.vue";

export default {
    AccettazioneList,
};
